// extracted by mini-css-extract-plugin
export var root = "styles-module--root--1h03s";
export var transparent = "styles-module--transparent--kMXcX";
export var logo = "styles-module--logo--3et5j";
export var svg = "styles-module--svg--3LI_d";
export var nonWispy = "styles-module--nonWispy--ssirm";
export var wispy = "styles-module--wispy--3wKar";
export var hamburger = "styles-module--hamburger--2c6vG";
export var links = "styles-module--links--1eMJ3";